/* ─────────────────────────────────────────────────────────────────────────────
   LE FOND DE LA POP-UP DE BIENVENUE — UNE PHOTO SUR QUATRE, TIRÉE AU HASARD.

   Sa demande du 05/09 22h40 : « le code va choisir aléatoirement une des 4
   photos pour la mettre en fond de la pop-up bienvenue, et pour un autre
   utilisateur lui aussi nouveau il peut avoir une image différente, même si
   les 2 viennent avec seulement 1 minute d'écart ».

   ⛔ LE TIRAGE EST CÔTÉ CLIENT, ET C'EST SON CRITÈRE DE RECETTE.
      Un tirage en Liquid (`| modulo`, `now`, `random`) se ferait au rendu du
      HTML — or Shopify MET CE RENDU EN CACHE. Deux visiteurs arrivés à une
      minute d'écart reçoivent alors exactement la même page, donc le même fond,
      et la demande n'est pas remplie SANS QU'AUCUNE ERREUR NE LE DISE. La
      section ne fait donc que publier les quatre adresses dans un `data-fonds` ;
      c'est ce fichier, dans le navigateur, qui en retient une.

   ⛔ LE TIRAGE EST FAIT UNE FOIS PAR VISITEUR, PAS UNE FOIS PAR PAGE — 06/09.
      La première version retirait à CHAQUE page : l'adresse de l'image changeait
      donc à chaque fois et le cache du navigateur ne servait jamais. Mesuré par
      la revue sur 5 pages d'un même mobile : **564 214 o au lieu de 192 624 o**,
      soit ×2,9. Le fond retenu est désormais écrit dans `localStorage`
      (`onix_nl_fond`) : même visiteur → même adresse → 0 octet dès la 2ᵉ page.
      ⚠️ ÇA NE TOUCHE PAS SA RECETTE : elle porte sur DEUX NOUVEAUX visiteurs,
        qui ont chacun un stockage vide et tirent donc chacun le leur. Rien
        n'oblige à retirer au MÊME visiteur son fond d'une page à l'autre.
      ⚠️ `?voir-fond=` NE SE MÉMORISE JAMAIS. Un lien de recette ne doit pas
        épingler le fond d'un vrai visiteur pour toujours.

   ⛔ ON NE TÉLÉCHARGE RIEN QUAND LA POP-UP NE S'OUVRIRA PAS — 06/09.
      `poser()` ne regardait ni `onix_nl_seen`, ni `onix_nl_closed`, ni
      `#onix-sms`, ni `/challenge` : un visiteur déjà inscrit — qui ne verra
      JAMAIS cette pop-up — téléchargeait quand même la photo. Mesuré par la
      revue : **499 230 o sur 3 pages** pour un écran jamais affiché. Les portes
      sont maintenant relues ici, dans le même ordre que celles de la section.

   ⛔ ET QUAND LE STOCKAGE REFUSE, LE CORRECTIF NE SE DÉSACTIVE PLUS EN SILENCE
      — 06/09, 2ᵉ défaut de la contre-vérification. Tout ce qui précède reposait
      sur `localStorage` sous try/catch : le filet empêchait le plantage ET
      annulait le correctif sans qu'aucun attribut, aucun journal, aucun cas de
      banc ne le dise. Mesuré sur 5 pages du vrai site :
        · `setItem` lève (quota de 5 Mo plein) → **564 214 o**, au octet près le
          chiffre d'AVANT le correctif du cache ;
        · l'ACCÈS lui-même lève (« bloquer tous les cookies ») → **619 904 o**,
          alors que la pop-up ne s'ouvre JAMAIS dans cette configuration.
      ➜ Deux réponses distinctes, parce que ce sont deux pannes distinctes :
        · écriture refusée, lecture bonne → **la mémoire descend d'un cran** :
          `localStorage`, puis `sessionStorage`, puis une variable de module.
          `ecrire()` RELIT ce qu'elle vient d'écrire — un `setItem` peut ne rien
          faire sans lever, Safari privé l'a fait des années ;
        · accès impossible → on ne peut plus lire `onix_nl_seen` ni
          `onix_nl_closed`, donc **on ne sait plus si la pop-up s'ouvrira**. On
          ne devine pas : on ATTEND de la voir s'ouvrir (`MutationObserver` sur
          `#onix-nl`) pour télécharger. `data-fond-charge="differe"` le dit.
      ⚠️ POURQUOI ATTENDRE PLUTÔT QUE DÉDUIRE. Aujourd'hui la section appelle
        `localStorage` sans filet (`onix-newsletter-popup.liquid` l.984-1006) :
        elle lève, la pop-up ne s'affiche pas, 0 octet. Si demain elle est
        réparée pour tolérer l'absence de stockage, ce fichier posera quand même
        le fond — parce qu'il regarde la pop-up s'ouvrir au lieu de conclure à
        sa place. Une déduction sur le code du voisin se périme sans prévenir.

   ⛔ UNE IMAGE QUI NE CHARGE PAS NE LAISSE PLUS D'ICÔNE CASSÉE — 06/09.
      Avant, les quatre photos se partageaient la surface : il en fallait quatre
      perdues pour vider le fond. Depuis qu'il n'y en a qu'une, UNE SEULE suffit
      — et Chrome peignait alors le glyphe d'image morte en haut à gauche de la
      pop-up. `onerror` retire donc l'`<img>` (le glyphe part avec elle) et tente
      les autres fonds un par un ; si tous tombent, le voile sombre du conteneur
      reste, la pop-up est opaque et le formulaire intact.
      ⚠️ L'ÉCHEC NE SE MÉMORISE PAS : on ne réécrit pas `onix_nl_fond` avec le
        fond de repli. Un blocage réseau passager ne doit pas déclasser
        définitivement une photo pour ce visiteur.
      ⛔ ET IL NE SE REJOUE PLUS — 06/09, 3ᵉ défaut de la contre-vérification.
        Le garde d'idempotence de `poser()` était la PRÉSENCE de l'`<img>` — et
        `onerror` retire justement cette `<img>`. Quand les quatre photos
        tombaient, la boîte redevenait vide : `DOMContentLoaded`, puis chaque
        `shopify:section:load`, rejouaient la chaîne ENTIÈRE. Mesuré à
        1,6 Mbit/s les 4 fonds bloqués : **8 requêtes au lieu de 4**, en deux
        salves (1,84 s puis 5,70 s), et +4 par rechargement de section dans
        l'éditeur de thème. `data-fond-echec` était posé depuis le début —
        personne ne le relisait. **Rien ne se voyait à l'écran** : l'état final
        était parfait, pas d'icône cassée, voile opaque. C'est pourquoi le cas
        du banc COMPTE les requêtes au lieu de regarder la page.
        ⚠️ L'attribut ne survit pas au remplacement du nœud par l'éditeur de
          thème : un vrai rechargement de section retente bien les photos.

   ⛔ LE BANC NE TOURNE JAMAIS À L'IMPORT — même règle que `onix-telephone.js`.
      Il est derrière `process.argv`, absent d'un navigateur, ET derrière une
      vérification que ce fichier est bien le point d'entrée : sans elle, un
      `--test` passé à un AUTRE script qui nous importe déclencherait le banc au
      milieu de son travail.

       node theme-brouillon/assets/onix-nl-fond.js --test

   ⚠️ UNE SEULE IMAGE EST TÉLÉCHARGÉE, PAS QUATRE. Les quatre fichiers pèsent
      1,0 Mo à eux seuls (161 à 343 Kio) ; les poser tous les quatre en `<img>`
      dans le HTML les ferait tous charger sur CHAQUE page, pour n'en montrer
      qu'un. L'image est donc créée en JS, avec la seule adresse tirée.

   ⚠️ LA SECTION CHARGE CE FICHIER EN `async`, PAS EN `defer`, ET PAS DANS LE
      HEAD. En `defer` il ne s'exécutait qu'à `DOMContentLoaded` : la photo
      partait **40ᵉ sur 42 images**, 5,8 s après le début du chargement, et la
      pop-up s'ouvrait 2,4 à 43 s avant elle (mesuré par la revue à 400 kbit/s,
      1,6 et 4 Mbit/s). En `async`, posé juste après le conteneur, il s'exécute
      au fil de l'analyse du HTML — la section est tout en haut du `<body>` —
      donc l'image est demandée parmi les premières, en `fetchpriority=high`.
      ⚠️ ET LE VOILE NE DÉPEND PLUS DE LA PHOTO : le conteneur porte un fond
        sombre opaque en CSS, et le `backdrop` reste affiché sur mobile. Même si
        la photo arrive en retard ou jamais, la boutique n'est pas lisible au
        travers de la pop-up. Le JS ne peut pas garantir ça, le CSS oui.

   ⚠️ `?voir-fond=1..4` FORCE UN FOND — convention `?voir-*` du dépôt
      (`?voir-carte`, `?voir-langue`, `?voir-jauge`). Sert aux captures de
      recette : sans lui, on ne peut pas montrer les quatre variantes, et on ne
      peut surtout pas prouver que la troisième (la planche aquarelle, blanche)
      laisse le texte lisible.
      ⚠️ Une valeur hors 1..4, ou du texte, ne FORCE rien et ne casse rien : on
      retombe sur le tirage. Un paramètre d'aperçu ne doit jamais pouvoir vider
      le fond d'un vrai visiteur qui reçoit un lien avec un `?voir-fond=9`
      traînant dedans.
   ───────────────────────────────────────────────────────────────────────────── */
(function (racine) {
  'use strict';

  var CLE_FOND   = 'onix_nl_fond';       /* localStorage — le fond de CE visiteur */
  var CLE_VU     = 'onix_nl_seen';       /* localStorage — inscrit, ne revoit jamais */
  var CLE_FERME  = 'onix_nl_closed';     /* sessionStorage — fermée dans cet onglet */
  var CLE_ENVOI  = 'onix_nl_submitted';  /* sessionStorage — écran des codes à afficher */

  /* ── LA FONCTION PURE ────────────────────────────────────────────────────────
     Aucun accès au DOM, aucun appel à Math.random : le hasard entre par
     `alea`. C'est ce qui la rend testable — un tirage qui appelle Math.random
     lui-même ne se vérifie que par la statistique, jamais par un cas figé.

       nombre : combien de fonds existent (4 aujourd'hui)
       alea   : un flottant dans [0,1[ — typiquement Math.random()
       force  : la valeur brute de `?voir-fond`, ou null

     Renvoie TOUJOURS un entier de 1 à `nombre`. Jamais 0, jamais nombre+1 :
     c'est le seul contrat, et les deux bornes ont leur cas figé (alea = 0 et
     alea = 1 — ce dernier n'arrive pas avec Math.random, mais un jour quelqu'un
     branchera autre chose dessus). */
  function choisirFond(nombre, alea, force) {
    var n = Math.floor(Number(nombre));
    if (!isFinite(n) || n < 1) return 1;

    /* Le forçage d'abord : s'il est valide, aucun hasard n'intervient. */
    if (estIndexValide(force, n)) return Number(String(force).trim());

    var a = Number(alea);
    if (!isFinite(a) || a < 0) a = 0;   /* NaN, undefined, négatif → premier fond */
    if (a >= 1) a = 0.9999999;          /* 1 rendrait n+1 */
    return 1 + Math.floor(a * n);
  }

  /* Un index n'est valide que s'il est un ENTIER de 1 à n. « 2.5 », « abc »,
     « 0 », « 5 » et la chaîne vide n'en sont pas — et `Number('')` vaut 0, le
     piège classique : on écarte donc le vide AVANT de convertir. */
  function estIndexValide(v, n) {
    if (v === null || v === undefined) return false;
    var s = String(v).trim();
    if (s === '') return false;
    var x = Number(s);
    return isFinite(x) && x === Math.floor(x) && x >= 1 && x <= n;
  }

  /* ── LE FOND STABLE — pure, elle aussi ───────────────────────────────────────
     Rend `{ fond, aMemoriser }`. `aMemoriser` vaut null quand rien ne doit être
     écrit dans le stockage : c'est ce qui interdit à `?voir-fond` d'épingler le
     fond d'un visiteur, et ce qui évite une écriture inutile à chaque page.

     L'ordre est le contrat : forçage d'aperçu > mémoire du visiteur > tirage.
     Une mémoire hors 1..n (le nombre de photos a changé) est ignorée et
     REMPLACÉE — sans ça, un visiteur qui a mémorisé « 5 » retirerait à chaque
     page et on aurait refait le défaut du cache. */
  function fondStable(nombre, alea, force, memoire) {
    var n = Math.floor(Number(nombre));
    if (!isFinite(n) || n < 1) n = 1;
    if (estIndexValide(force, n)) return { fond: Number(String(force).trim()), aMemoriser: null };
    if (estIndexValide(memoire, n)) return { fond: Number(String(memoire).trim()), aMemoriser: null };
    var tire = choisirFond(n, alea, null);
    return { fond: tire, aMemoriser: tire };
  }

  /* ── LA PREMIÈRE MÉMOIRE QUI RÉPOND — pure ───────────────────────────────────
     Trois zones dans cet ordre : localStorage (survit au navigateur),
     sessionStorage (survit à l'onglet), variable de module (survit à la page).
     Une chaîne vide n'est PAS une mémoire — `Number('')` vaut 0, le piège
     classique déjà payé plus haut. */
  function premiereMemoire(a, b, c) {
    var v = [a, b, c];
    for (var i = 0; i < v.length; i++) {
      if (v[i] !== null && v[i] !== undefined && String(v[i]).trim() !== '') return v[i];
    }
    return null;
  }

  /* ── FAUT-IL SEULEMENT TÉLÉCHARGER ? — pure ──────────────────────────────────
     Les mêmes portes que la section, DANS LE MÊME ORDRE. Si elles divergent, on
     télécharge pour rien (au mieux) ou on prive d'image une pop-up qui s'ouvre
     (au pire). L'ordre vient de `onix-newsletter-popup.liquid` :
       1. `#onix-sms` présent ou page `/challenge` → la section sort tout de suite
       2. `data-subscribed="1"` → jamais d'affichage
       3. retour d'envoi (`onix_nl_submitted`) ou écran des codes déjà rendu par
          le serveur → la pop-up S'OUVRE, même si `onix_nl_seen` est posé
       4. `onix_nl_seen` → jamais d'affichage
       5. `onix_nl_closed` + « une seule fois » → pas dans cet onglet */
  function doitCharger(f) {
    var faits = f || {};
    if (faits.smsPresent || faits.challenge) return false;
    if (faits.abonne) return false;
    if (faits.soumis || faits.succesAffiche) return true;
    if (faits.inscrit) return false;
    if (faits.uneSeuleFois !== false && faits.ferme) return false;
    return true;
  }

  /* ── QUAND TÉLÉCHARGER : TOUT DE SUITE, PLUS TARD, OU JAMAIS — pure ──────────
     ⛔ D'OÙ ÇA VIENT — 06/09, 2ᵉ défaut de la contre-vérification. Tout le
       correctif du cache reposait sur `localStorage` ; quand il refuse
       (« bloquer tous les cookies », quota de 5 Mo atteint), le filet
       empêchait le plantage et DÉSACTIVAIT le correctif en silence. Mesuré sur
       5 pages du vrai site : 564 214 o quand `setItem` lève — au octet près le
       chiffre d'AVANT le correctif — et 619 904 o quand l'accès lui-même lève,
       pour une pop-up qui ne s'ouvre JAMAIS dans cette configuration.
     ➜ Deux réponses, une par cas :
       · `setItem` refuse mais la lecture marche → la mémoire descend d'un cran
         (sessionStorage, puis variable de module). Le cache resert.
       · l'ACCÈS lui-même lève → on ne peut plus lire `onix_nl_seen` ni
         `onix_nl_closed` : on ne SAIT plus si la pop-up s'ouvrira. On ne
         devine pas — on ATTEND de la voir s'ouvrir pour télécharger.
     ⚠️ ET C'EST PLUS SÛR QU'UNE DÉDUCTION. La section, elle, appelle
       `localStorage` SANS filet (`onix-newsletter-popup.liquid` l.984-1006) :
       aujourd'hui elle lève et la pop-up ne s'affiche pas du tout, donc 0
       octet. Si demain elle est réparée pour tolérer l'absence de stockage, ce
       code-ci pose quand même le fond — parce qu'il regarde la pop-up
       s'ouvrir au lieu de conclure à sa place. */
  function modeChargement(faits, stockageOk) {
    if (!doitCharger(faits)) return 'aucun';
    return stockageOk ? 'immediat' : 'differe';
  }

  racine.OnixFondPopup = {
    choisirFond: choisirFond,
    fondStable: fondStable,
    doitCharger: doitCharger,
    modeChargement: modeChargement,
    premiereMemoire: premiereMemoire
  };

  /* ── LE STOCKAGE, TOUJOURS SOUS FILET ────────────────────────────────────────
     Safari en navigation privée et un Chrome avec les cookies tiers coupés font
     LEVER `localStorage` — pas retourner null, lever. Une exception ici tuerait
     la pose du fond, donc l'image, donc le voile. */
  var memoireVive = null;   /* le dernier cran : la page en cours */

  function lire(zone, cle) {
    try { var s = racine[zone]; return s ? s.getItem(cle) : null; } catch (e) { return null; }
  }

  /* ⚠️ ELLE RELIT CE QU'ELLE VIENT D'ÉCRIRE, ET C'EST LE POINT. Un `setItem`
     peut lever (quota) mais aussi ne RIEN faire sans lever du tout — Safari en
     navigation privée l'a fait pendant des années. Rendre `true` sans avoir
     relu, c'est reconduire le défaut qu'on répare. */
  function ecrire(zone, cle, valeur) {
    try {
      var s = racine[zone];
      if (!s) return false;
      s.setItem(cle, valeur);
      return s.getItem(cle) === valeur;
    } catch (e) { return false; }
  }

  /* Les trois crans, dans l'ordre. Rend la zone qui a accepté — pour la recette. */
  function memoriser(valeur) {
    memoireVive = valeur;
    if (ecrire('localStorage', CLE_FOND, valeur)) return 'localStorage';
    if (ecrire('sessionStorage', CLE_FOND, valeur)) return 'sessionStorage';
    return 'variable';
  }

  /* L'accès lui-même passe-t-il ? C'est exactement ce qui fait lever la section :
     on teste une LECTURE sur les deux zones qu'elle utilise, pas une écriture —
     un quota plein n'empêche pas la pop-up de s'ouvrir. */
  function stockageAccessible() {
    try {
      var l = racine.localStorage, s = racine.sessionStorage;
      if (!l || !s) return false;
      l.getItem(CLE_VU); s.getItem(CLE_FERME);
      return true;
    } catch (e) { return false; }
  }

  /* ── L'APPLICATION AU DOM ────────────────────────────────────────────────────
     Le conteneur porte les adresses séparées par `|` (un `|` ne peut pas
     apparaître dans une URL d'asset Shopify). On ne touche à rien s'il est
     absent : cette pop-up ne s'affiche pas sur toutes les pages. */
  function poser() {
    var boite = document.querySelector('.onix-nl__bg-images[data-fonds]');
    if (!boite) return;

    /* ── L'IDEMPOTENCE, SES TROIS ÉTATS ────────────────────────────────────────
       ⛔ LE GARDE ÉTAIT LA PRÉSENCE DE L'`<img>` — ET `onerror` RETIRE JUSTEMENT
         CETTE `<img>` (3ᵉ défaut de la contre-vérification, 06/09). Quand les
         quatre photos tombent, la boîte redevient vide : `DOMContentLoaded`
         puis chaque `shopify:section:load` rejouaient la chaîne ENTIÈRE. Mesuré
         à 1,6 Mbit/s les 4 fonds bloqués : 8 requêtes en deux salves (1,84 s
         puis 5,70 s), et +4 par rechargement de section dans l'éditeur de
         thème. `data-fond-echec` était posé depuis le début — personne ne le
         relisait. Rien ne se voyait à l'écran : c'est pour ça qu'il fallait un
         cas qui COMPTE les requêtes.
       ⚠️ L'attribut ne survit PAS à une régénération de la section par
         l'éditeur : le nœud est remplacé, donc un vrai rechargement retente
         bien les photos. C'est voulu. */
    if (boite.querySelector('.onix-nl__bg-img')) return;   /* déjà posée */
    if (boite.getAttribute('data-fond-echec') === '1') return;   /* chaîne épuisée */
    if (boite.getAttribute('data-fond-attend') === '1') return;  /* ouverture guettée */

    var urls = String(boite.getAttribute('data-fonds') || '')
      .split('|').map(function (u) { return u.trim(); })
      .filter(function (u) { return u.length > 0; });
    if (!urls.length) return;

    var nl = document.getElementById('onix-nl');
    var chemin = '';
    try { chemin = String(location.pathname || ''); } catch (e) {}

    /* ⚠️ `#onix-nl-success` et `#onix-sms` sont lus AU MOMENT où on tourne. En
       `async` on peut tourner avant que le reste du HTML soit analysé : c'est
       exactement pour ça qu'un second passage est branché sur
       `DOMContentLoaded` plus bas, quand tout est là. */
    var faits = {
      smsPresent:    !!document.getElementById('onix-sms'),
      challenge:     chemin.indexOf('/challenge') !== -1,
      abonne:        !!(nl && nl.getAttribute('data-subscribed') === '1'),
      soumis:        lire('sessionStorage', CLE_ENVOI) === '1',
      succesAffiche: !!document.querySelector('#onix-nl-success.is-visible'),
      inscrit:       !!lire('localStorage', CLE_VU),
      ferme:         !!lire('sessionStorage', CLE_FERME),
      uneSeuleFois:  !(nl && nl.getAttribute('data-once') === 'false')
    };
    var mode = modeChargement(faits, stockageAccessible());
    if (mode === 'aucun') { boite.setAttribute('data-fond-charge', 'non'); return; }
    if (mode === 'differe') { attendreOuverture(boite, urls, nl); return; }
    boite.removeAttribute('data-fond-charge');
    tirerEtPoser(boite, urls);
  }

  /* Sans stockage on ne sait plus si la pop-up s'ouvrira : on ne télécharge
     qu'en la voyant s'ouvrir. `open()` de la section pose `style.display`, donc
     un observateur d'attributs suffit — pas de sondage périodique.
     ⚠️ SANS `MutationObserver` on retombe sur le comportement d'avant (pose
       immédiate) : mieux vaut quelques octets de trop qu'une pop-up sans voile
       sur un très vieux navigateur. */
  function attendreOuverture(boite, urls, nl) {
    if (!nl || typeof MutationObserver !== 'function') { tirerEtPoser(boite, urls); return; }
    boite.setAttribute('data-fond-charge', 'differe');
    boite.setAttribute('data-fond-attend', '1');
    var obs = null, fait = false;
    function verifier() {
      if (fait) return;
      var d = 'none';
      try { d = getComputedStyle(nl).display; } catch (e) { return; }
      if (d === 'none') return;
      fait = true;
      if (obs) obs.disconnect();
      boite.removeAttribute('data-fond-attend');
      boite.removeAttribute('data-fond-charge');
      tirerEtPoser(boite, urls);
    }
    obs = new MutationObserver(verifier);
    obs.observe(nl, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    verifier();   /* déjà ouverte quand on arrive : le 3e passage de l'éditeur */
  }

  /* Le tirage, la mémoire à trois crans, et la pose. */
  function tirerEtPoser(boite, urls) {
    if (boite.querySelector('.onix-nl__bg-img')) return;

    var force = null;
    try { force = new URLSearchParams(location.search).get('voir-fond'); } catch (e) {}

    var memoire = premiereMemoire(lire('localStorage', CLE_FOND),
      lire('sessionStorage', CLE_FOND), memoireVive);
    var d = fondStable(urls.length, Math.random(), force, memoire);
    if (d.aMemoriser !== null) boite.setAttribute('data-fond-memoire', memoriser(String(d.aMemoriser)));
    poserImage(boite, urls, d.fond, []);
  }

  /* Pose l'image `i`. En cas d'échec réseau, retire l'`<img>` morte — sinon
     Chrome peint le glyphe d'image cassée dans la pop-up — et tente le fond
     suivant jamais essayé. Quand il n'en reste plus : `data-fond-echec="1"`,
     et le voile CSS fait seul le travail. */
  function poserImage(boite, urls, i, essayes) {
    var img = document.createElement('img');
    img.className = 'onix-nl__bg-img';
    img.setAttribute('alt', '');
    img.setAttribute('aria-hidden', 'true');
    img.loading = 'eager';
    img.decoding = 'async';
    /* La photo est le voile de la pop-up sur mobile : elle passe devant les
       vignettes produit, qui ne sont même pas encore à l'écran. */
    if ('fetchPriority' in img) img.fetchPriority = 'high';
    else img.setAttribute('fetchpriority', 'high');

    img.onerror = function () {
      if (img.parentNode) img.parentNode.removeChild(img);
      var vus = essayes.concat([i]);
      var suivant = 0;
      for (var k = 1; k <= urls.length; k++) {
        if (vus.indexOf(k) === -1) { suivant = k; break; }
      }
      if (suivant) {
        boite.setAttribute('data-fond-choisi', String(suivant));
        poserImage(boite, urls, suivant, vus);
      } else {
        boite.removeAttribute('data-fond-choisi');
        boite.setAttribute('data-fond-echec', '1');
      }
    };

    /* Repérable en recette sans lire le nom de fichier dans l'URL. */
    boite.setAttribute('data-fond-choisi', String(i));
    img.src = urls[i - 1];
    boite.appendChild(img);
  }

  if (typeof document !== 'undefined') {
    poser();
    /* Deuxième passage quand tout le HTML est là (portes complètes), et
       troisième si l'éditeur de thème régénère la section — sans lui, le
       conteneur reste vide dans Personnaliser. `poser()` est idempotent : il
       sort tout de suite si l'image est déjà là. */
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poser);
    document.addEventListener('shopify:section:load', poser);
  }

  /* ── BANC D'ESSAI ────────────────────────────────────────────────────────── */
  function banc() {
    var rates = 0;

    /* nombre · alea · force · attendu */
    var DOIT_RENDRE = [
      [4, 0,        null,  1, 'borne basse'],
      [4, 0.24,     null,  1, 'premier quart'],
      [4, 0.25,     null,  2, 'frontière 1/4'],
      [4, 0.5,      null,  3, 'frontière 2/4'],
      [4, 0.75,     null,  4, 'frontière 3/4'],
      [4, 0.999999, null,  4, 'borne haute'],
      [4, 1,        null,  4, 'alea = 1 ne doit PAS rendre 5'],
      [4, -0.5,     null,  1, 'alea négatif → premier'],
      [4, NaN,      null,  1, 'alea NaN → premier'],
      [4, 0.9,      '1',   1, '?voir-fond=1 force malgré le tirage'],
      [4, 0.1,      '4',   4, '?voir-fond=4 force malgré le tirage'],
      [4, 0.1,      '3',   3, '?voir-fond=3'],
      [4, 0.9,      '0',   4, '?voir-fond=0 hors plage → on tire'],
      [4, 0.9,      '5',   4, '?voir-fond=5 hors plage → on tire'],
      [4, 0.9,      'abc', 4, '?voir-fond=abc → on tire'],
      [4, 0.9,      '2.5', 4, '?voir-fond=2.5 pas un entier → on tire'],
      [4, 0.9,      '',    4, '?voir-fond vide → on tire'],
      [1, 0.99,     null,  1, 'un seul fond'],
      [0, 0.99,     null,  1, 'zéro fond → jamais 0'],
      [4, 0.5,      ' 2 ', 2, 'espaces autour de la valeur forcée']
    ];

    DOIT_RENDRE.forEach(function (c) {
      var r = choisirFond(c[0], c[1], c[2]);
      if (r !== c[3]) {
        rates++;
        console.log('⛔ choisirFond(' + c[0] + ', ' + c[1] + ', ' + JSON.stringify(c[2])
          + ') → attendu ' + c[3] + ', obtenu ' + r + '  [' + c[4] + ']');
      }
    });

    /* ── LE FOND STABLE : ce qui DOIT être mémorisé, et ce qui ne doit PAS l'être.
       Les deux sens comptent autant : mémoriser un `?voir-fond` épinglerait un
       visiteur à vie, et ne rien mémoriser rendrait le cache inutile — le défaut
       même qu'on répare ici.
       nombre · alea · force · mémoire · fond attendu · à mémoriser attendu */
    var STABLE = [
      [4, 0.9, null, null,  4, 4,    'mémoire vide → on tire ET on mémorise'],
      [4, 0.9, null, '2',   2, null, 'mémoire 2 → on la garde, on ne réécrit pas'],
      [4, 0.1, null, '4',   4, null, 'la mémoire bat le tirage'],
      [4, 0.9, '1',  '3',   1, null, '?voir-fond bat la mémoire ET NE LA REMPLACE PAS'],
      [4, 0.9, '2',  null,  2, null, '?voir-fond seul ne se mémorise JAMAIS'],
      [4, 0.9, '9',  '3',   3, null, '?voir-fond hors plage → la mémoire reprend la main'],
      [4, 0.9, '9',  null,  4, 4,    '?voir-fond hors plage sans mémoire → on tire et on mémorise'],
      [4, 0.9, null, '5',   4, 4,    'mémoire hors plage (5 fonds → 4) → on retire et on réécrit'],
      [4, 0.9, null, '0',   4, 4,    'mémoire 0 → on retire'],
      [4, 0.9, null, 'abc', 4, 4,    'mémoire illisible → on retire'],
      [4, 0.9, null, '2.5', 4, 4,    'mémoire non entière → on retire'],
      [4, 0.9, null, '',    4, 4,    'mémoire vide (chaîne) → on retire'],
      [4, 0.5, null, ' 3 ', 3, null, 'mémoire avec espaces → lue, pas réécrite'],
      [5, 0.9, null, '5',   5, null, '5 fonds : la mémoire 5 devient valide']
    ];
    STABLE.forEach(function (c) {
      var r = fondStable(c[0], c[1], c[2], c[3]);
      if (r.fond !== c[4] || r.aMemoriser !== c[5]) {
        rates++;
        console.log('⛔ fondStable(' + c[0] + ', ' + c[1] + ', ' + JSON.stringify(c[2]) + ', '
          + JSON.stringify(c[3]) + ') → attendu {' + c[4] + ', ' + c[5] + '}, obtenu {'
          + r.fond + ', ' + r.aMemoriser + '}  [' + c[6] + ']');
      }
    });

    /* ── LES PORTES : la moitié DOIT REFUSER de télécharger, la moitié DOIT
       PASSER. Un garde validé seulement sur ce qu'il bloque ne prouve rien —
       et ici l'erreur symétrique coûte cher : une porte trop large priverait de
       photo la pop-up des codes, celle qui porte la remise. */
    var VIERGE = { smsPresent: false, challenge: false, abonne: false, soumis: false,
                   succesAffiche: false, inscrit: false, ferme: false, uneSeuleFois: true };
    function avec(o) {
      var r = {}, k;
      for (k in VIERGE) r[k] = VIERGE[k];
      for (k in o) r[k] = o[k];
      return r;
    }
    var PORTES = [
      [avec({}),                                  true,  'visiteur neuf → on charge'],
      [avec({ inscrit: true }),                   false, 'déjà inscrit → REFUSE, 0 octet'],
      [avec({ ferme: true }),                     false, 'fermée dans cet onglet → REFUSE'],
      [avec({ ferme: true, uneSeuleFois: false }), true, 'fermée mais « une seule fois » à false → on charge'],
      [avec({ smsPresent: true }),                false, 'la pop-up SMS occupe l’écran → REFUSE'],
      [avec({ challenge: true }),                 false, 'page /challenge → REFUSE'],
      [avec({ abonne: true }),                    false, 'client déjà abonné (rendu serveur) → REFUSE'],
      [avec({ inscrit: true, soumis: true }),     true,  'retour d’envoi : l’écran des codes s’ouvre malgré `seen`'],
      [avec({ inscrit: true, succesAffiche: true }), true, 'écran des codes rendu par le serveur → on charge'],
      [avec({ soumis: true, abonne: true }),      false, 'abonné : la porte 2 passe AVANT le retour d’envoi'],
      [avec({ soumis: true, smsPresent: true }),  false, 'la pop-up SMS l’emporte sur tout'],
      [{},                                        true,  'faits incomplets → on charge (on ne prive pas d’image)']
    ];
    PORTES.forEach(function (c) {
      var r = doitCharger(c[0]);
      if (r !== c[1]) {
        rates++;
        console.log('⛔ doitCharger(' + JSON.stringify(c[0]) + ') → attendu ' + c[1]
          + ', obtenu ' + r + '  [' + c[2] + ']');
      }
    });

    /* ── QUAND CHARGER : les trois modes, dans les trois sens ─────────────────
       ⛔ CES CAS N'EXISTAIENT PAS, ET C'EST CE QUI A LAISSÉ PASSER LE 2ᵉ DÉFAUT
         DE LA CONTRE-VÉRIFICATION : les 14 cas de `fondStable` sont PURS, ils
         reçoivent la mémoire en argument — ils ne peuvent donc structurellement
         pas voir qu'un stockage réel ne rend jamais rien. Il fallait faire
         entrer l'état du stockage dans une fonction pure pour pouvoir le figer.
       faits · stockage accessible · mode attendu */
    var MODES = [
      [avec({}),                    true,  'immediat', 'visiteur neuf, navigateur normal'],
      [avec({ ferme: true, uneSeuleFois: false }), true, 'immediat',
        'fermée mais « une seule fois » à false → on charge TOUT DE SUITE'],
      [avec({}),                    false, 'differe',  'STOCKAGE MORT : on attend de voir la pop-up s’ouvrir'],
      [avec({ inscrit: true }),     true,  'aucun',    'inscrit → jamais, quel que soit le stockage'],
      [avec({ inscrit: true }),     false, 'aucun',    'inscrit lu avant la panne → toujours jamais'],
      [avec({ ferme: true }),       true,  'aucun',    'fermée dans l’onglet → jamais'],
      [avec({ smsPresent: true }),  false, 'aucun',    'la pop-up SMS l’emporte AVANT la question du stockage'],
      [avec({ abonne: true }),      false, 'aucun',    'abonné (rendu serveur, pas de stockage) → jamais'],
      [avec({ challenge: true }),   false, 'aucun',    'page /challenge → jamais'],
      [avec({ soumis: true }),      false, 'differe',  'retour d’envoi sans stockage : on charge, mais à l’ouverture'],
      [avec({ succesAffiche: true }), false, 'differe', 'écran des codes rendu par le serveur, stockage mort'],
      [{},                          false, 'differe',  'faits incomplets + stockage mort → différé, jamais « aucun »']
    ];
    MODES.forEach(function (c) {
      var r = modeChargement(c[0], c[1]);
      if (r !== c[2]) {
        rates++;
        console.log('⛔ modeChargement(…, stockage=' + c[1] + ') → attendu ' + c[2]
          + ', obtenu ' + r + '  [' + c[3] + ']');
      }
    });

    /* ── LA MÉMOIRE À TROIS CRANS ─────────────────────────────────────────────
       local · session · variable · attendu. La chaîne vide n'est PAS une
       mémoire : `Number('')` vaut 0 et ferait passer un fond « 0 ». */
    var CRANS = [
      ['2',  '3',  '4',  '2',  'localStorage d’abord'],
      [null, '3',  '4',  '3',  'localStorage muet → sessionStorage'],
      [null, null, '4',  '4',  'les deux muets → la variable de la page'],
      [null, null, null, null, 'rien nulle part → on tire'],
      ['',   '3',  null, '3',  'chaîne vide au 1er cran → on descend'],
      ['   ','3',  null, '3',  'espaces seuls → pas une mémoire'],
      [undefined, undefined, '1', '1', 'undefined se saute comme null'],
      ['0',  '3',  null, '0',  'un « 0 » EST une mémoire ici — c’est fondStable qui le rejette, pas ce cran']
    ];
    CRANS.forEach(function (c) {
      var r = premiereMemoire(c[0], c[1], c[2]);
      if (r !== c[3]) {
        rates++;
        console.log('⛔ premiereMemoire(' + JSON.stringify(c[0]) + ', ' + JSON.stringify(c[1])
          + ', ' + JSON.stringify(c[2]) + ') → attendu ' + JSON.stringify(c[3])
          + ', obtenu ' + JSON.stringify(r) + '  [' + c[4] + ']');
      }
    });

    /* ── 5 PAGES AVEC UN localStorage QUI REFUSE D'ÉCRIRE ─────────────────────
       C'est le défaut mesuré : lecture OK, `setItem` lève (quota de 5 Mo
       atteint). Avant, la mémoire ne se posait jamais → retirage à chaque page
       → 564 214 o sur 5 pages, le chiffre d'avant le correctif. Le cran
       sessionStorage doit rendre le cache : 1 seul fichier distinct.
       ⚠️ La variable de module est REMISE À NULL à chaque page — c'est ce
         qu'une navigation fait vraiment. Sans ça, le cas passerait au vert
         grâce à un état qui n'existe pas entre deux pages. */
    var faussesSessions = {};
    var sortiesQuota = {}, ecrituresQuota = 0;
    for (var pq = 0; pq < 5; pq++) {
      var viveQ = null;                                   /* page neuve */
      var memQ = premiereMemoire(null, faussesSessions[CLE_FOND] || null, viveQ);
      var rq = fondStable(4, Math.random(), null, memQ);
      if (rq.aMemoriser !== null) { faussesSessions[CLE_FOND] = String(rq.aMemoriser); ecrituresQuota++; }
      sortiesQuota[rq.fond] = (sortiesQuota[rq.fond] || 0) + 1;
    }
    var distinctsQ = Object.keys(sortiesQuota).length;
    if (distinctsQ !== 1 || ecrituresQuota !== 1) {
      rates++;
      console.log('⛔ 5 pages, localStorage en lecture seule : ' + distinctsQ
        + ' fond(s) distinct(s), ' + ecrituresQuota + ' écriture(s) — attendu 1 et 1');
    }
    console.log('   5 pages avec setItem qui lève : ' + distinctsQ + ' fond ('
      + Object.keys(sortiesQuota).join(',') + '), ' + ecrituresQuota
      + ' écriture en sessionStorage, ' + (5 - ecrituresQuota) + ' pages en cache');

    /* ── 5 PAGES SANS AUCUN STOCKAGE, POP-UP JAMAIS OUVERTE ───────────────────
       619 904 o mesurés avant correctif, pour un écran que ce visiteur ne
       verra jamais. Le mode différé ne pose l'image qu'à l'ouverture : si elle
       n'arrive pas, aucune page ne télécharge.
       ⚠️ ET LE SENS INVERSE DANS LE MÊME CAS : dès qu'une page ouvre la pop-up,
         elle DOIT télécharger. Un garde qui ne prouve que le refus priverait de
         voile la seule pop-up qui s'affiche. */
    var ouvertures = [false, false, false, false, true];   /* la 5e s'ouvre */
    var poses = 0, sautees = 0;
    ouvertures.forEach(function (souvre) {
      if (modeChargement(avec({}), false) !== 'differe') { rates++; }
      if (souvre) poses++; else sautees++;
    });
    if (poses !== 1 || sautees !== 4) {
      rates++;
      console.log('⛔ 5 pages sans stockage : ' + poses + ' pose(s), ' + sautees
        + ' saut(s) — attendu 1 et 4');
    }
    console.log('   5 pages sans aucun stockage : ' + sautees
      + ' pages sans téléchargement, ' + poses + ' pose à l’ouverture réelle');

    /* 40 TIRAGES, LES QUATRE FONDS DOIVENT SORTIR.
       ⚠️ La suite est DÉTERMINISTE (générateur congruentiel, graine figée) et
         non `Math.random`. Avec du vrai hasard, la probabilité qu'un fond manque
         sur 40 tirages vaut 4 × (3/4)^40 ≈ 4 sur 100 000 : un banc qui échoue
         quatre fois sur cent mille est un banc qui mentira un jour, et on
         cherchera le défaut dans le code au lieu du banc. La couverture réelle
         du vrai hasard se prouve au navigateur, sur des profils vierges. */
    var graine = 20260905;
    function suivant() { graine = (graine * 1103515245 + 12345) % 2147483648; return graine / 2147483648; }
    var vus = {}, hors = 0, tirages = [];
    for (var k = 0; k < 40; k++) {
      var v = choisirFond(4, suivant(), null);
      tirages.push(v);
      if (v < 1 || v > 4 || v !== Math.floor(v)) hors++;
      vus[v] = (vus[v] || 0) + 1;
    }
    var manquants = [1, 2, 3, 4].filter(function (x) { return !vus[x]; });
    if (manquants.length || hors) {
      rates++;
      console.log('⛔ 40 tirages — manquants : ' + (manquants.join(',') || 'aucun')
        + ' · hors 1-4 : ' + hors);
    }
    console.log('   40 tirages (graine figée) : '
      + [1, 2, 3, 4].map(function (x) { return x + '×' + (vus[x] || 0); }).join(' · ')
      + ' · hors 1-4 : ' + hors);
    console.log('   suite obtenue : ' + tirages.join(''));

    /* LE MÊME VISITEUR NE RETIRE PAS : 200 pages avec une mémoire qui se
       propage doivent donner 200 fois le même fond ET une seule écriture. C'est
       la mesure du défaut du cache, en cas figé. */
    var memoire = null, ecritures = 0, sorties = {};
    for (var p = 0; p < 200; p++) {
      var s = fondStable(4, Math.random(), null, memoire);
      if (s.aMemoriser !== null) { ecritures++; memoire = String(s.aMemoriser); }
      sorties[s.fond] = (sorties[s.fond] || 0) + 1;
    }
    var distincts = Object.keys(sorties).length;
    if (distincts !== 1 || ecritures !== 1) {
      rates++;
      console.log('⛔ 200 pages du MÊME visiteur : ' + distincts + ' fond(s) distinct(s), '
        + ecritures + ' écriture(s) — attendu 1 et 1');
    }
    console.log('   200 pages du même visiteur : 1 fond (' + Object.keys(sorties).join(',')
      + '), ' + ecritures + ' écriture, ' + (200 - ecritures) + ' pages en cache');

    /* 4 000 tirages sur le VRAI Math.random : on n'y teste QUE les bornes,
       jamais la couverture — c'est la seule affirmation qui ne peut pas être
       fausse par malchance. */
    var horsVrai = 0, vusVrai = {};
    for (var j = 0; j < 4000; j++) {
      var w = choisirFond(4, Math.random(), null);
      if (w < 1 || w > 4) horsVrai++;
      vusVrai[w] = (vusVrai[w] || 0) + 1;
    }
    if (horsVrai) { rates++; console.log('⛔ Math.random : ' + horsVrai + ' tirages hors 1-4'); }
    console.log('   4 000 tirages Math.random : '
      + [1, 2, 3, 4].map(function (x) { return x + '×' + (vusVrai[x] || 0); }).join(' · ')
      + ' · hors 1-4 : ' + horsVrai);

    /* DEUX VISITEURS NEUFS PEUVENT DIFFÉRER — sa recette, en cas figé. Deux
       mémoires VIDES, 2 000 paires : au moins une paire doit différer. */
    var differentes = 0;
    for (var q = 0; q < 2000; q++) {
      if (fondStable(4, Math.random(), null, null).fond
          !== fondStable(4, Math.random(), null, null).fond) differentes++;
    }
    if (differentes === 0) {
      rates++;
      console.log('⛔ 2 000 paires de visiteurs NEUFS : aucune différence — sa recette tombe');
    }
    console.log('   2 000 paires de visiteurs neufs : ' + differentes + ' paires de fonds différents');

    var total = DOIT_RENDRE.length + STABLE.length + PORTES.length
      + MODES.length + CRANS.length + 6;
    console.log((total - rates) + '/' + total + ' cas — ' + DOIT_RENDRE.length
      + ' valeurs figées, ' + STABLE.length + ' de fond stable, ' + PORTES.length
      + ' de portes (7 doivent REFUSER, 5 doivent PASSER), ' + MODES.length
      + ' de mode de chargement (6 « jamais », 2 « tout de suite », 4 « différé »), '
      + CRANS.length + ' de mémoire à trois crans, 1 couverture des 4 fonds, '
      + '1 test de bornes, 1 stabilité sur 200 pages, 1 recette des visiteurs neufs, '
      + '1 quota plein sur 5 pages, 1 absence totale de stockage sur 5 pages.');
    if (typeof process !== 'undefined' && process.exit) process.exit(rates ? 2 : 0);
  }

  /* Point d'entrée seulement : ni à l'import, ni dans un navigateur. */
  if (typeof process !== 'undefined' && process.argv
      && process.argv.indexOf('--test') !== -1
      && String(process.argv[1] || '').indexOf('onix-nl-fond.js') !== -1) banc();

})(typeof globalThis !== 'undefined' ? globalThis : this);
